export default `
    <div id="#= data.id #" name="#= data.id #" class="insert-object-button #= data.containerClasses || ""# #=data.bsc||""#" # if (data.disabled) { # disabled # } #>
        <a class="insert-object-icon #=data.iconType || ""#">
        # if (data.iconType == 'tech' || data.iconType == 'small-tech') { #
            <i class="fas tech-badge"></i>
        # } #
        </a><a data-label-for-id="#= data.id #" class="insert-object-label bind-label link #= data.labelClasses || ""#" # if (data.header) { # data-bind="text: #= data.header #" # } # ></a>
    </div>
`;
